import { CONDITION_TYPE, VALIDATE } from '@cognitiv/cicada-ui';
import { JobDefinitionsState } from 'ducks/job-definitions/slices';
import { JobDefinitionsCreatePayload } from 'ducks/types/payload-types';

export type JobFormState = JobDefinitionsState[number] & {
  batch_descriptor: string;
};

export const default_job: JobFormState = {
  cpu: 1,
  gpu: 0,
  max_retries: 0,
  memory_gb: 1,
  shared_memory_mb: 64,
  cpu_architecture_id: 1,
  cpu_architecture_name: 'x86',
  storage_gb: 1,
  description: '',
  docker_image: '',
  startup_command: '',
  project_id: null,
  project_name: '',
  job_definition_id: null,
  job_definition_name: '',
  location_group_name: '',
  location_group_id: 1,
  timeout_seconds: 86400,
  timeout_seconds_masked: '24:00:00',
  result_method_id: null,
  result_method_name: '',
  billing_identifier: '',
  prevent_preemption_name: 'No',
  prevent_preemption: false,
  organization_id: null,
  organization_name: '',
  created_by: '',
  created_datetime_utc: '',
  stdout_success_text: '',
  is_archived: false,
  modified: false,
  sort_datetime_utc: '',
  created_datetime_utc_formatted: '',
  sort_datetime: '',
  local_timezone: '',
  created_datetime_formatted: '',
  uuid: '',
  batch_descriptor: '',
};

export const default_job_definition: JobDefinitionsCreatePayload = {
  job_definition_name: '',
  docker_image: '',
  startup_command: '',
  description: null,
  location_group_id: 1,
  cpu_architecture_id: 1,
  cpu_architecture_name: 'x86',
  result_method_id: 1,
  timeout_seconds: 86400, // 24 hours
  max_retries: 0,
  stdout_success_text: null,
  billing_identifier: '',
  cpu: 1,
  gpu: 0,
  memory_gb: 1,
  shared_memory_mb: 64,
  storage_gb: 1,
  prevent_preemption: false,
  parameters: [],
};

export const run_validation = {
  docker_image: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Docker Image is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
  cpu: {
    type: VALIDATE.NUMBER,
    conditions: [
      {
        error: 'CPU > 128',
        type: CONDITION_TYPE.LESS_THAN,
        values: [129],
      },
    ],
  },
  memory_gb: {
    type: VALIDATE.NUMBER,
    conditions: [
      {
        error: 'Memory GB > 1952',
        type: CONDITION_TYPE.LESS_THAN,
        values: [1953],
      },
    ],
  },
  gpu: {
    type: VALIDATE.NUMBER,
    conditions: [
      {
        error: 'GPU > 4',
        type: CONDITION_TYPE.LESS_THAN,
        values: [5],
      },
    ],
  },
  shared_memory_mb: {
    type: VALIDATE.NUMBER,
    conditions: [
      {
        error: 'Shared Memory MB > 32767',
        type: CONDITION_TYPE.LESS_THAN,
        values: [32768],
      },
      {
        error: 'Shared Memory MB < 64',
        type: CONDITION_TYPE.GREATER_THAN,
        values: [63],
      },
    ],
  },
  timeout_seconds: {
    type: VALIDATE.NUMBER,
    conditions: [
      {
        error: 'Timeout Exceeds Limit',
        type: CONDITION_TYPE.LESS_THAN,
        values: [2147483647],
      },
    ],
  },
  storage_gb: {
    type: VALIDATE.NUMBER,
    conditions: [
      {
        error: 'Storage GB > 32766',
        type: CONDITION_TYPE.LESS_THAN,
        values: [32767],
      },
    ],
  },
  max_retries: {
    type: VALIDATE.NUMBER,
    conditions: [
      {
        error: 'Max Retries > 10',
        type: CONDITION_TYPE.LESS_THAN,
        values: [11],
      },
    ],
  },
  cpu_architecture_name: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Cpu Architecture is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
  location_group_name: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Location Group is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
  result_method_name: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Result Method is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
};

export const create_validation = {
  job_definition_name: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Job Definition Name is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
  docker_image: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Docker Image is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
  STARTUP_COMMAND: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Startup Command is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
};
